<template>
    <div class="chained-select">
        <div class="form--field-row">
            <div class="form--field">
                <ui-model-provider v-model="mainSelectValue" v-slot="{ value, updateValue }">
                    <ui-select
                            :disabled="isDisabled"
                            :has-errors="!!errors[nameMainSelect]"
                            :value="value"
                            :name="nameMainSelect"
                            :required="true"
                            @change="updateValue">
                        <template slot="label">
                            {{ labelMainSelect }}
                        </template>
                        <ui-option :value="option.id" v-for="option in options" :key="option.id">
                            {{ option.label }}
                        </ui-option>
                        <template v-if="errors[nameMainSelect]" slot="messages">
                            <form-field-messages :messages="{ 'error': errors[nameMainSelect] }"/>
                        </template>
                    </ui-select>
                </ui-model-provider>
            </div>
        </div>
        <div class="form--field-row" v-if="children">
            <div class="form--field">
                <ui-model-provider v-model="chainedSelectValue" v-slot="{ value, updateValue }">
                    <ui-select :has-errors="!!errors[nameChainedSelect]"
                            :value="value"
                            :name="nameChainedSelect"
                            :required="true"
                            @change="updateValue">
                        <template slot="label">
                            {{ labelChainedSelect }}
                        </template>
                        <ui-option :value="option.id" v-for="option in children" :key="option.id">
                            {{ option.label }}
                        </ui-option>
                        <template v-if="errors[nameChainedSelect]" slot="messages">
                            <form-field-messages :messages="{ 'error': errors[nameChainedSelect] }"/>
                        </template>
                    </ui-select>
                </ui-model-provider>
            </div>
        </div>
    </div>
</template>

<script>
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option';
    import FormFieldMessages from '../form-field-messages/form-field-messages';

    export default {
        components: {
            FormFieldMessages,
            UiModelProvider,
            UiSelect,
            UiOption,
        },
        props: {
            nameMainSelect: {
                type: String,
                required: true,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            labelMainSelect: {
                type: String,
                required: true,
            },
            nameChainedSelect: {
                type: String,
                required: true,
            },
            labelChainedSelect: {
                type: String,
                required: true,
            },
            items: {
                type: Object,
                required: true,
            },
            initialMainSelectValue: {
                type: String,
                default: '',
            },
            errors: {
                type: Object,
                default: () => ({}),
            },
            initialChainedSelectValue: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                mainSelectValue: this.initialMainSelectValue,
                chainedSelectValue: this.initialChainedSelectValue,
            };
        },
        computed: {
            children() {
                return this.mainSelectValue ? this.items.children[this.mainSelectValue] : null;
            },
            options() {
                return this.items.items;
            },
        },
    };
</script>
